import React, { useState, useEffect } from "react";
import i18n from "i18next";

import { fetchWrapper } from "../../helpers/fetchwrapper";

// Fluent UI Imports
import { baseUrl } from "../../helpers/constants";
import { IKonfigurationSt } from "../../Models/IKonfigurationSt";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Field,
  Textarea,
} from "@fluentui/react-components";
import { MailArrowForwardRegular } from "@fluentui/react-icons";

interface IRequestOfferDialogProps {
  finishedConfig: IKonfigurationSt | undefined;
  isDialogOpen: boolean;
  onDismiss: any;
  onOfferRequested: any;
}

function RequestOfferDialog(props: IRequestOfferDialogProps) {
  const [finishedConfig, setFinishedConfig] = useState<
    IKonfigurationSt | undefined
  >(props.finishedConfig);

  const handleFinishedConfigValuesChange = (name: string, val: any) => {
    setFinishedConfig((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
  };

  useEffect(() => {
    setFinishedConfig(props.finishedConfig);
  }, [props.finishedConfig]);

  const requestOffer = () => {
    if (finishedConfig) {
      fetchWrapper
        .postWithAuth(
          `${baseUrl}/api/configurator/RequestOfferForConfiguration`,
          finishedConfig,
        )
        .then((result) => {
          if (result) {
            props.onOfferRequested(result);
          }
        });
    }
  };

  const isSaveDisabled = () => {
    if (finishedConfig?.infoAnVertrieb) {
      if (finishedConfig?.infoAnVertrieb.length > 199) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  return (
    <>
      <Dialog open={props.isDialogOpen}>
        <DialogSurface>
          <DialogBody>
            <DialogTitle>{i18n.t<string>("requestOffer")}</DialogTitle>
            <DialogContent>
              {i18n.t<string>("requestOfferSubText")}
              <Field
                style={{ fontWeight: 700, marginTop: "10px" }}
                label={i18n.t<string>("infoAnVertrieb")}
              >
                <Textarea
                  resize="vertical"
                  value={finishedConfig?.infoAnVertrieb}
                  onChange={(ev, val) => {
                    handleFinishedConfigValuesChange(
                      "infoAnVertrieb",
                      val.value,
                    );
                  }}
                />
              </Field>
            </DialogContent>
            <DialogActions>
              <Button
                icon={<MailArrowForwardRegular />}
                appearance="primary"
                disabled={isSaveDisabled()}
                onClick={() => requestOffer()}
              >
                {i18n.t<string>("requestOffer")}
              </Button>
              <Button
                onClick={() => {
                  props.onDismiss(true);
                }}
              >
                {i18n.t<string>("cancel")}
              </Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </>
  );
}

export default RequestOfferDialog;
